import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useEffect } from 'react';
import { BackToHomeButton, DeleteSuccessWrapper, Title } from './DeleteSuccess.styles';

const DeleteSuccess: FC = () => {
  const { t } = useGlobalState();
  const router = useRouter();

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional mount-only redirect
  useEffect(() => {
    setTimeout(() => {
      router.push('/');
    }, 5000);
  }, []);

  return (
    <DeleteSuccessWrapper>
      <Title>{t(MasterTranslation.AccDeleteAccountSucceed)}</Title>
      <BackToHomeButton href='/'>
        {t(MasterTranslation.AccBackToHome).replace('{PARCEL MONITOR}', 'PARCEL MONITOR')}
      </BackToHomeButton>
    </DeleteSuccessWrapper>
  );
};

export default DeleteSuccess;
